<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import Flickity from "flickity";
import { get, merge } from "lodash";
import StripeHeader from "stripe-header";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  components: {
    StripeHeader
  },
  props: {
    customOptions: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      slider: null,
      headerPosition: 'top',
      headerClass: null,
      headerCol: null,
      headerAlign: null,
      carouselClass: null,
      paddingYDefault: 5
    }
  },
  mounted() {
    this.headerPosition = this.content.header_position || 'top';
    switch(this.headerPosition) {
      case 'top':
        this.headerClass = ['col-12'];
        this.carouselClass = ['col-12'];
        break;
      case 'side':
        this.headerClass = ['col-12', 'col-sm-5', 'col-lg-4', 'd-flex', 'align-items-center'];
        this.headerCol = 12;
        this.headerAlign = 'left';
        this.carouselClass = ['col-12', 'col-sm-7', 'col-lg-8', 'd-flex', 'align-items-center'];
        break;
    }
    Vue.nextTick(() => {
      this.registerAnimation();
      if (Fandom.exists(this.content.children)) {

        this.slider = new Flickity(this.$refs["flickity-carousel"], merge({
          draggable: ">1",
          groupCells: this.perPage > 3,
          prevNextButtons: this.hasPrevNextButtons,
          arrowShape: "M47.89,1,.78,48.11a2.68,2.68,0,0,0,0,3.78L47.89,99a2.67,2.67,0,0,0,3.79,0l1.58-1.57a2.67,2.67,0,0,0,0-3.79L13.42,53.79h83.9A2.67,2.67,0,0,0,100,51.12V48.88a2.67,2.67,0,0,0-2.68-2.67H13.42L53.26,6.36a2.67,2.67,0,0,0,0-3.79L51.68,1A2.67,2.67,0,0,0,47.89,1Z",
          cellAlign: this.content.align || 'center',
          pageDots: ">1",
          wrapAround: (this.content.children.length >= this.perPage)
        }, this.customOptions));

        this.slider.on("dragStart", () => {
          $(this.$refs["flickity-carousel"]).find('.flickity-carousel-item').css('pointer-events', 'none');
        });

        this.slider.on("dragEnd", () => {
          $(this.$refs["flickity-carousel"]).find('.flickity-carousel-item').css('pointer-events', 'all');
        });
      }
    });
  },
  computed: {
    hasPrevNextButtons() {
      return this.content.prev_next_buttons || false;
    },
    componentClasses() {
      let classes = [ this.contentType, this.paddingY ];
      if (this.content.theme) {
        classes.push(`${this.content.theme}-theme`);
      }
      return classes;
    },
    contentStyle() {
      return {
        "background-color": this.content.background_color,
        "color": this.content.color
      };
    },
    perPage() {
      let pages = parseInt(get(this, "content.per_page", null));
      pages = pages ? pages :  parseInt(get(this, "content.set", 1)) * 3;
      return pages;
    },
    pagerClass() {
      return `per-page-${this.perPage}`;
    },
    cellAlignClass() {
      return this.content.align ? `align-${this.content.align}` : "align-center";
    },
    aspectRatioClass() {
      let ar = this.content.aspect_ratio_class ? this.content.aspect_ratio_class : 'ar-16by9';
      return ar;
    },
    sidePaddingClass() {
      if (this.content.padding_x) {
        return this.content.padding_x;
      } else if (this.pagerClass === 'per-page-3' && this.cellAlignClass === 'align-center' && this.aspectRatioClass === 'ar-16by9') {
        return 'px-0';
      } else {
        return 'px-3';
      }
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="componentClasses" :style="contentStyle" class="inview_animate" :id="contentId" stripe-carousel-component>
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container-fluid">
      <div class="row">
        <div :class="headerClass">
          <slot name="heading">
            <stripe-header :content="content" :col="headerCol" :align="headerAlign" class="my-4"></stripe-header>
          </slot>
        </div>
        <div :class="carouselClass" class="pr-0">
          <div class="w-100">
            <div class="flickity-container" :class="sidePaddingClass">
              <div class="flickity-carousel mb-4" ref="flickity-carousel" :class="[pagerClass, {'hide-title-description-mobile': content.hide_tile_description_mobile}]">
                <div
                  class="flickity-carousel-item overflow-hidden"
                  v-for="(child, index) in content.children"
                  :key="`carousel-slide-${index}`"
                  :child_name="child"
                  :class="[{'vertical-slide': aspectRatioClass == 'ar-2by3'}, cellAlignClass, `${aspectRatioClass}-item`]"
                >
                  <div class="w-100 position-relative" :class="aspectRatioClass">
                    <component 
                      :is="getContent(child).layout" 
                      :content="getContent(child)" 
                      :animation="false" 
                      :iconsBottom="aspectRatioClass == 'ar-2by3'"
                    ></component>
                  </div>
                </div>
                <div class="flickity-carousel-item" :class="{'vertical-slide': aspectRatioClass == 'ar-2by3'}" v-if="content.has_more_children && content.view_more_link">
                  <div class="w-100" :class="aspectRatioClass">
                    <slot name="last-tile"></slot>
                  </div>
                </div>
              </div>
            </div>
            <div class="dots-spacer" v-if="!!slider && slider.pageDots.dots.length > 1"></div>
            <div class="w-100 d-flex justify-content-center mb-4" v-if="content.url">
              <a :href="content.url.url" :target="getTarget(content.url)" class="btn" :class="getSecondaryButtonClass(content.button_class, content.theme)">
                {{content.url.title}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-carousel-component] {
  position: relative;

  &.dark-theme {
    background-color: $dark;
    color: $white;

    .flickity-page-dots .dot {
      background-color: $white;
    }
  }

  .flickity {
    &-prev-next-button {
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        position: relative;
        width: 45%;
        height: 45%;
        left: 0;
        top: 0;
      }
    }

    /* side shadows */
    &-viewport::after,
    &-viewport::before {
      z-index: 1;
      opacity: 0;
      content: '';
      height: 100%;
      width: 5.25rem;
      position: absolute;
      pointer-events: none;
      transition: opacity .5s;
      background: transparent;
    }

    &-carousel {
      .flickity-viewport::after, &:not(.hide-left-shadow) .flickity-viewport::before {
        opacity: 1;
      }

      &-item:not(.is-selected) .inview_animate_zoom_in {
        animation-name: none !important;
      }
    }
  }

  /* position dots up a bit */
  .flickity-page-dots {
    bottom: -32px;

    .dot:first-child {
      &:last-child {
        display: none;
      }
    }
  }

  .dots-spacer {
    height: calc(1.5rem + #{$flickity-dots-height});
  }

  .ar-2by3 {
    & ::v-deep .icon {
      height: 30%;
    }
  }

  .flickity-carousel-item {
    padding-left: $grid-gap;
    width: 100%;
  }

  @include media-breakpoint-down(sm) {
    .flickity-carousel-item {
      width: 65%;
    }

    .per-page-3 {
      .flickity-carousel-item {
        width: 85%;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }

    .dots-spacer,
    .flickity-page-dots,
    .flickity-prev-next-button,
    .flickity-prev-next-button,
    .flickity-viewport::after,
    .flickity-viewport::before {
      display: none;
    }
  }

  @include media-breakpoint-up(md) {
    @for $i from 4 through 6 {
      .per-page-#{$i} {
        .flickity-carousel-item {
          &.align-left {
            width: calc((100% / 3) - .5rem);
          }
          &.align-center {
            width: calc((100% / 3) - 1rem);
          }
        }
      }
    }

    @for $i from 2 through 3 {
      .per-page-#{$i} {
        .flickity-carousel-item {
          &.align-left {
            width: 50%;
          }
          &.align-center {
            width: calc(50% - 1rem);
          }
        }
      }
    }
  }

  @include media-breakpoint-up(lg) {
    @for $i from 4 through 6 {
      .per-page-#{$i} {
        .flickity-carousel-item {
          &.align-left {
            width: calc((100% / 4) - .5rem);
          }
          &.align-center {
            width: calc((100% / 4) - 1rem);
          }
        }
      }
    }
  }

  @include media-breakpoint-up(xl) {
    @for $i from 2 through 6 {
      .per-page-#{$i} {
        .flickity-carousel-item {
          &.align-left,
          &.align-center {
            width: calc(100% / #{$i} - (#{($i - 1) / $i}rem));
          }
        }
      }

      .per-page-3 .flickity-carousel-item.align-center.ar-16by9-item {
        width: calc(50% - .5rem);
      }
    }
  }
}
</style>